import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      question: 'Do you handle custom alloys and specialized materials?',
      answer: 'Yes, we work with a comprehensive range of materials including carbon steel, stainless steel, aluminum, titanium, and exotic alloys. Our team has deep technical knowledge of custom material specifications and established relationships with certified suppliers to source specialized alloys that meet your exact project requirements throughout South Africa.'
    },
    {
      question: 'What is your typical lead time for projects?',
      answer: 'Lead times vary based on project complexity and scope. Standard fabrication projects typically range from 2-4 weeks, while complex or large-scale projects may require 6-12 weeks. We provide detailed timelines during the consultation phase and work efficiently to meet your deadlines. For urgent requirements, we offer expedited services across Gauteng and surrounding regions.'
    },
    {
      question: 'Do you offer on-site inspections and consultations?',
      answer: 'Absolutely. Our engineering team provides comprehensive on-site inspections, measurements, and consultations throughout South Africa. This ensures precise specifications and allows us to address site-specific challenges before fabrication begins. We believe in thorough planning and clear communication throughout the project lifecycle.'
    },
    {
      question: 'What quality certifications and standards do you follow?',
      answer: 'WeldPoint adheres to ISO 9001:2015 standards and follows SABS (South African Bureau of Standards) and international AWS (American Welding Society) guidelines. Our welders hold current certifications, and we maintain comprehensive documentation for material traceability and quality assurance. We can arrange for Mill Test Certificates and third-party inspection services to ensure complete transparency and compliance.'
    },
    {
      question: 'Can you handle both small and large-scale projects?',
      answer: 'Yes, our Midrand facility is equipped with modern machinery and tooling to handle projects of all scales. From small custom fabrication pieces to large industrial installations, we apply the same rigorous quality standards and attention to detail. Our team\'s diverse expertise ensures we can adapt to your specific project requirements.'
    },
    {
      question: 'What geographic areas in South Africa do you serve?',
      answer: 'Our primary facility is based in Midrand, Gauteng, and we serve clients throughout South Africa including Johannesburg, Pretoria, Cape Town, Durban, and Port Elizabeth. For large-scale projects, we offer on-site fabrication and installation services. Our logistics team coordinates shipping and delivery nationwide to ensure timely project completion wherever you are located.'
    }
  ];

  return (
    <section id="faq" className="py-20 lg:py-32 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="fade-in text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm font-bold text-secondary tracking-wider uppercase mb-4">Frequently Asked Questions</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-primary mb-6">
            Everything You Need to Know
          </h2>
          <p className="text-lg text-foreground-muted">
            Find answers to common questions about our services, processes, and capabilities.
          </p>
        </div>

        <div className="fade-in max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card border border-border-light rounded-xl px-6 shadow-soft hover:shadow-elegant transition-shadow"
              >
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="text-lg font-serif font-bold text-primary pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-foreground-muted pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
